import Swiper from 'swiper';
import debounce from 'lodash.debounce';
import inView from 'in-view';

export default class Pillars {
	constructor() {
		this.pillarCarousel = document.querySelector('[data-is="pillars"]');
		this.pillars = document.querySelectorAll('[data-is="pillar"]');
		this.breakPoint = 992;
		this.hasVideos = false;
		this.videos = [];

		this.debouncedUpdate = debounce(this.update.bind(this), 300);
		this.debouncedScroll = debounce(this.scroll.bind(this), 100);
		window.addEventListener('resize', this.debouncedUpdate);
		window.addEventListener('scroll', this.debouncedScroll);

		this.pillars.forEach((pillar) => {
			const video = pillar.querySelector('video');
			if (video) {
				pillar.addEventListener('mouseover', (e) => {
					video.play();
				});
				pillar.addEventListener('mouseout', (e) => {
					video.pause();
				});
				video.addEventListener('loadeddata', (e) => {
					if (window.innerWidth > this.breakPoint) {
						video.pause();
					}
				});
				video.addEventListener('video-ready', (e) => {
					if (window.innerWidth > this.breakPoint) {
						this.loadAllVideos();
					} else {
						this.loadSwiperVideo();
					}
				});
				this.videos.push(video);
				this.hasVideos = true;
			}
		});

		this.init();
	}

	init() {
		if (window.innerWidth <= this.breakPoint) {
			this.enableSwiper();
		}
		if (window.innerWidth > this.breakPoint) {
			this.pauseAllVideos();
		}
	}

	playAllVideos() {
		this.videos.forEach(function (video) {
			video.play();
		});
	}

	pauseAllVideos() {
		this.videos.forEach(function (video) {
			video.currentTime = 0;
			video.pause();
		});
	}

	loadAllVideos() {
		this.videos.forEach(function (video) {
			video.src = video.dataset.src;
		});
	}

	loadSwiperVideo() {
		const currentVideo =
			this.swiper.slides[this.swiper.activeIndex].querySelector('video');
		if (currentVideo.src.length <= 0) {
			currentVideo.src = currentVideo.dataset.src;
		}
	}

	enableSwiper() {
		this.swiper = new Swiper(this.pillarCarousel, {
			slidesPerView: 'auto',
			slideClass: 'pillar',
			on: {
				init: function (swiper) {},
				slideChange: () => {
					this.loadSwiperVideo();
				},
			},
		});
	}

	disableSwiper() {
		if (this.swiper) {
			this.swiper.destroy();
		}
	}

	update() {
		if (window.innerWidth <= this.breakPoint) {
			this.enableSwiper();
			if (this.hasVideos) {
				this.playAllVideos();
			}
		} else {
			this.disableSwiper();
			if (this.hasVideos) {
				this.pauseAllVideos();
			}
		}
	}

	scroll() {
		if (!this.pillarCarousel) {
			return;
		}

		const isInView = this.isElementInViewport(this.pillarCarousel);

		if (window.innerWidth <= this.breakPoint && isInView) {
			this.pillarCarousel
				.querySelector('.component-pillars')
				.classList.add('component-pillars--visible');
		} else {
			this.pillarCarousel
				.querySelector('.component-pillars')
				.classList.remove('component-pillars--visible');
		}
	}

	isElementInViewport(el) {
		if (!el) {
			return;
		}

		var rect = el.getBoundingClientRect();

		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <=
				(window.innerHeight ||
					document.documentElement
						.clientHeight) /* or $(window).height() */ &&
			rect.right <=
				(window.innerWidth ||
					document.documentElement
						.clientWidth) /* or $(window).width() */
		);
	}
}
